import http from "../core/http";

const group = 'bagAction';

export const locateBagRequest  = async (data) =>
    await http.post(`${group}/locate`,  data).then(r => r.data).catch(http.defaultCatch);

export const receiveBagRequest = async (data) =>
    await http.post(`${group}/receive`, data).then(r => r.data).catch(http.defaultCatch);

export const deliverBagRequest = async (data) =>
    await http.post(`${group}/deliver`, data).then(r => r.data).catch(http.defaultCatch);

export const forwardBagRequest = async (data) =>
    await http.post(`${group}/forward`, data).then(r => r.data).catch(http.defaultCatch);

export const disposeBagRequest = async (data) =>
    await http.post(`${group}/dispose`, data).then(r => r.data).catch(http.defaultCatch);
